<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Akten</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="height: Calc(90vh - 50px);" >
  <DataGridView [DataUrl]="Url()" #Grid  KeyProperty="key" [UseUrlFilter]="false">
    <DataGridViewColumn field="key" header="Lauf" [DataType]="Types.Number" />
    <DataGridViewColumn field="firstName" header="Vorname" [DataType]="Types.String" />
    <DataGridViewColumn field="lastName" header="Nachname" [DataType]="Types.String" />
    <DataGridViewColumn field="versichertennumer" header="Versichertennummer" [DataType]="Types.String" />
    <DataGridViewColumn [isFixed]="true" [AllowOrder]="false" [AllowSearch]="false">
      <ng-template #cell let-row>
        <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(row)"></div>
      </ng-template>
      <ng-template #header>

      </ng-template>
    </DataGridViewColumn>

  </DataGridView>
</div>
